// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"16adcd2e","163":"4f0fcfd8","174":"5292b63f","823":"d3d5bdee","871":"7b7d22c9","950":"cba02dcc","957":"4c16cbe3","974":"1389716f"}[chunkId] + ".chunk.js";
};